import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { useLanguage } from '../../../../../../contexts/LanguageContext';
import { formatDateOnly } from '../../../../../../utils/dateUtils';
import { createTruncatedTextForTable } from '../../../../../../utils/textUtils';
import useChassisInfoData from '../../../hooks/useChassisInfoData';

import ChassisDetailTabs from './ChassisDetailTabs';

const ChassisInfoDialog = ({ visible, onHide, chassisNo }) => {
    const { t } = useLanguage();
    const [detailVisible, setDetailVisible] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    const { items, totalRecords, loading, first, rows, onPage } = useChassisInfoData(chassisNo);

    const openDetail = (row) => {
        if (!row?.id) return;
        setSelectedId(row.id);
        setDetailVisible(true);
    };

    const actionBodyTemplate = (rowData) => <i onClick={() => openDetail(rowData)} className="pi pi-history cursor-pointer text-blue-500 hover:text-blue-700" style={{ color: '#0B3187' }} title={t('warrantyClaims.tooltips.history')} />;

    return (
        <>
            <Dialog visible={visible} header={t('warranty.customerDeclaration.chassisInfo.header')} modal onHide={onHide}>
                <DataTable
                    value={items}
                    loading={loading}
                    paginator
                    lazy
                    totalRecords={totalRecords}
                    first={first}
                    rows={rows}
                    onPage={onPage}
                    rowsPerPageOptions={[10, 20, 50]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="{first} - {last} / {totalRecords}"
                    className="p-datatable-gridlines"
                    showGridlines
                    dataKey="id"
                    header={t('warranty.customerDeclaration.chassisInfo.tableHeader')}
                    emptyMessage={t('warranty.customerDeclaration.chassisInfo.emptyMessage')}
                    tableStyle={{ minWidth: '50rem' }}
                >
                    <Column key="actions" bodyClassName="text-center" header={t('common.history')} body={actionBodyTemplate} exportable={false} style={{ width: '5%' }} />
                    <Column key="dealerName" field="dealerName" header={t('warranty.customerDeclaration.chassisInfo.dealer')} style={{ width: '10%' }} body={(rowData) => createTruncatedTextForTable(rowData.dealerName, 40)} />
                    <Column key="warrClaimsNo" field="warrClaimsNo" header={t('dealerStockReport.claimNo')} style={{ width: '10%' }} />
                    <Column key="kmInformation" field="kmInformation" header={t('warranty.customerDeclaration.table.kmInformation')} body={(rowData) => (rowData.kmInformation == null ? '-' : Number(rowData.kmInformation).toLocaleString('tr-TR'))} />
                    <Column key="customerStatement" field="customerStatement" header={t('customerDefinition.history.customerStatement')} body={(rowData) => createTruncatedTextForTable(rowData.customerStatement || '-', 80)} />
                    <Column key="claimDate" field="claimDate" header={t('warranty.customerDeclaration.dialog.fields.serviceDeliveryDate')} style={{ width: '10%' }} body={(rowData) => formatDateOnly(rowData.claimDate)} />
                </DataTable>
            </Dialog>

            {detailVisible && <ChassisDetailTabs key={selectedId} visible={detailVisible} onHide={() => setDetailVisible(false)} id={selectedId} />}
        </>
    );
};

export default ChassisInfoDialog;
